import {
  Background,
  ModCfBackground,
  ModCfSpacers,
  Spacers,
} from "types/generic/types";
import {
  Infer,
  array,
  enums,
  nullable,
  object,
  string,
  union,
} from "superstruct";
import { ModCfCustomHtml } from "components/CustomHtml/types";
import { ModCfSms } from "components/Sms/types";
import { ModCfText } from "components/Text/types";
import { ModCfVideo } from "components/Video/types";
import { ModalType } from "components/ModalLayout";
import { contentToChildren } from "utilities/validatoros/types";

export const ModCfModalType = enums(["small", "medium", "large", "full"]);

export const ModCfModalStyle = object({
  contentful_id: string(),
  background: nullable(ModCfBackground),
  modalType: nullable(ModCfModalType),
  spacers: nullable(ModCfSpacers),
});

export const ModCfModal = object({
  id: string(),
  contentful_id: string(),
  customClass: nullable(string()),
  modalStyle: nullable(ModCfModalStyle),
  content: array(union([ModCfText, ModCfVideo, ModCfSms, ModCfCustomHtml])),
});

export const ModCfModalProps = contentToChildren(ModCfModal);

export type CfModalType = Infer<typeof ModCfModalType>;

export type CfModalProps = Infer<typeof ModCfModalProps>;

export interface ModalProps extends Background, Spacers {
  children: React.ReactNode;
  id: string;
  customClass?: string;
  modalType: ModalType;
}
